"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaPublicKeyToJSON = exports.RosettaPublicKeyFromJSONTyped = exports.RosettaPublicKeyFromJSON = exports.RosettaPublicKeyCurveTypeEnum = void 0;
/**
* @export
* @enum {string}
*/
var RosettaPublicKeyCurveTypeEnum;
(function (RosettaPublicKeyCurveTypeEnum) {
    RosettaPublicKeyCurveTypeEnum["secp256k1"] = "secp256k1";
    RosettaPublicKeyCurveTypeEnum["edwards25519"] = "edwards25519";
})(RosettaPublicKeyCurveTypeEnum = exports.RosettaPublicKeyCurveTypeEnum || (exports.RosettaPublicKeyCurveTypeEnum = {}));
function RosettaPublicKeyFromJSON(json) {
    return RosettaPublicKeyFromJSONTyped(json, false);
}
exports.RosettaPublicKeyFromJSON = RosettaPublicKeyFromJSON;
function RosettaPublicKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hex_bytes': json['hex_bytes'],
        'curve_type': json['curve_type'],
    };
}
exports.RosettaPublicKeyFromJSONTyped = RosettaPublicKeyFromJSONTyped;
function RosettaPublicKeyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hex_bytes': value.hex_bytes,
        'curve_type': value.curve_type,
    };
}
exports.RosettaPublicKeyToJSON = RosettaPublicKeyToJSON;
//# sourceMappingURL=RosettaPublicKey.js.map